






















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import moment from "moment";
import BaseVue from '../../core/BaseVue';
@Component({})
export default class DatePickerComponent extends BaseVue {
  @Prop() public placeholder: any;
  @Prop() public value: any;
  @Prop() public maxDate: any;
  @Prop() public minDate: any;
  @Prop() label!: string;
  private fechaSelected: any = null;
  max_date = this.maxDate || null;
  private months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  private days = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"];

  dateFormat(dt: any) {
    if (dt) return moment(dt).format("L");
  }

  @Watch("fechaSelected", { immediate: true })
  onFechaSelectedChange(val:any) {
    if(val)
    this.$emit("input", val);
  }
  
  @Watch("value", { immediate: true })
  onValueChange(val:any) {
    if (!val) this.fechaSelected = null;
    else this.fechaSelected = val;
  }
}
